import { Manager } from './Manager';
import { MiddlewareClient } from './core/MiddlewareClient';

const StethoMe = {
  Manager,
  MiddlewareClient,
};

export default StethoMe;
